import React from "react";
import Carousel from "react-material-ui-carousel";
import { Paper, Button, Box } from "@mui/material";
import Page1ForCarousal from "./page1";
import Page2ForCarousal from "./page2";
import Page3ForCarousal from "./page3";
const Overview = () => {
  const items = [
    {
      id: 1,
      component: <Page1ForCarousal />,
    },
    {
      id: 2,
      component: <Page2ForCarousal />,
    },
    {
      id: 3,
      component: <Page3ForCarousal />,
    },
  ];
  return (
    <div>
      <Box sx={{ mt: 3 }}>
        <Carousel animation="fade" animationDuration={100} autoPlay={true}>
          {items.map((item, i) => (
            <div key={item.id}>{item.component}</div>
          ))}
        </Carousel>
      </Box>
    </div>
  );
};

export default Overview;
